import React from 'react';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as CustomConfig from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataConfig";
import * as CustomMix from "Flow2/components/CustomCollections/CustomMix/CustomMix";
import * as AppController from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';
import { getUserNameById } from "Flow2/components/CustomCollections/CustomDataControllers/CustomUserController";
import SweetAlert from 'sweetalert2';
import { delay } from "q";
import { FormattedMessage } from 'react-intl';
import * as CustomForm from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFormController';

export const mainToolbarHeight = 96;
export const MAX_TIMEOUT = 15 * 60 * 1000; // 15 Minutes;
export const WAIT_TIMEOUT = 5000; // 5 Seconds;
export const isPMDB = () => AppController.isPMDB();
export const isNLW = () => AppController.isNLW();
export const isVifogra = () => AppController.isVifogra();
export const isFrancetv = () => AppController.isFrancetv();
export const isTranscoder1 = () => AppController.isTranscoder1();
export const isQnap = () => AppController.isQnap();
export const isb47 = () => AppController.isb47();
export const isSdk = () => AppController.isSdk();
export const getSortOptionsForApp = (sortOption, configClipInfo = []) => AppController.CustomAppEventListener("getSortOption", sortOption, configClipInfo);
export const isEven = (number) => number % 2 == 0;
export const isOdd = (number) => Math.abs(number % 2) == 1;
export const setActiveElement = (elementId, elements, option, parent = null, others) => CustomMix.setActiveElement(elementId, elements, option, parent = null, others);
export const getDeletedItem = ({ elements, currentItem, deletedElements }) => CustomMix.getDeletedItem({ elements, currentItem, deletedElements });
export const makeUniqueItems = ({ data, property }) => CustomForm.uniqueItemsDataForApp({ data, property });


export const makeCustomId = (length) => {
    let result = '';
    //const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const len = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * len));
        counter += 1;
    }
    return result;
}

export const isUpMaster = (appId) => {
    if (isPMDB() && appId && appId === CustomTypes.MASTER_UPLOAD_FORM) return true;
    return false;
}

export const showAutoCloseDlg = (htmlMsg, confirmBtnTxt, confirmCb, cancelBtnTxt, cancelCb) => {
    SweetAlert.fire({
        html: htmlMsg,
        // timer: WAIT_TIMEOUT,
        // timerProgressBar: true,
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonColor: CustomTypes.COLOR_RED,
        confirmButtonColor: CustomTypes.COLOR_BLACK,
        cancelButtonText: cancelBtnTxt,
        confirmButtonText: confirmBtnTxt
    }).then((result) => {
        // if (result.dismiss === SweetAlert.DismissReason.timer) {
        //     confirmCb();
        // }
        if (result.value) confirmCb();
        else cancelCb();
    })
}

export const setMinMaxDate = (configDate) => {
    let today = new Date();
    if (parseInt(configDate)) return today.setDate(today.getDate() + parseInt(configDate) - 2);
    return null;
}

export const showStyleForApp = (props) => {
    if (props && props.decaydate) {
        let expired = new Date(props.decaydate) - Date.now();
        if (expired < 0) return { ...CustomTypes.CUSTOM_LARGE_TEXT, color: "#d5001c", "-webkit-text-fill-color": "#d5001c" };
    }
    return CustomTypes.CUSTOM_LARGE_TEXT;
}

export const translateArrayIntlMsgForApp = (params, formatMessage) => {
    let translatedMsg = '';
    if (params && params.length) {
        params.forEach(item => {
            translatedMsg += formatMessage({ id: `customdata.${item.msg}` }) + " " + item.value + " ";
        });
        if (translatedMsg && translatedMsg.trim() !== "") {
            translatedMsg += "!";
            return translatedMsg;
        }
    }
    return params;
}

export const showConfirmDialogWithCallback = (htmlMsg, formatMessage, callback) => {
    SweetAlert.fire({
        html: formatMessage({ id: `customdata.${htmlMsg}` }),
        showConfirmButton: true,
        confirmButtonColor: CustomTypes.COLOR_RED,
        confirmButtonText: formatMessage({ id: `customdata.okMsg` })
    }).then(result => {
        if (result.value) {
            callback();
        }
    });
}


export const showIntlConfirmDialogWithCallback = (htmlMsg, formatMessage, callback) => {
    SweetAlert.fire({
        html: htmlMsg,
        showConfirmButton: true,
        confirmButtonColor: CustomTypes.COLOR_RED,
        confirmButtonText: formatMessage({ id: "customdata.okMsg" })
    }).then(result => {
        if (result.value) {
            callback();
        }
    });
}

export const createInputTag = (name, id, type = "text", isRequired = false) => {
    let inputBorder = "";
    if (isRequired) inputBorder = " border: 1px solid red; "
    return '<div style="margin-top: 10px;" ><label style="text-align: left; width: 90px; display: inline-block; font-size: 14px;">' + name + '</label><input style="width: 300px; color: gray; ' + inputBorder + '" type="' + type + '" id="' + id + '"></div>';
}

export const getDialogMessageObj = (data, confirmBtnTxt = "closeMsg", cancelBtnTxt = "cancelMsg") => {
    let messageObj =
    {
        html: data.html ? data.html : '',
        showCancelButton: true,
        confirmButtonColor: CustomTypes.COLOR_RED,
        cancelButtonColor: CustomTypes.COLOR_BLACK,
        cancelButtonText: data.formatMessage({ id: `customdata.${cancelBtnTxt}` }),
        confirmButtonText: data.formatMessage({ id: `customdata.${confirmBtnTxt}` })
    }

    if (data.messageId) {
        let message = data.formatMessage({ id: `customdata.${data.messageId}` })
        if (message)
            messageObj.html = messageObj.html + '<span>' + message + '</span>';
    }
    if (data.cancelButtonText) messageObj.cancelButtonText = data.formatMessage({ id: `customdata.${data.cancelButtonText}` });
    if (data.confirmButtonText) messageObj.confirmButtonText = data.formatMessage({ id: `customdata.${data.confirmButtonText}` })
    return messageObj;
}


export const isEqual = (object1, object2) => {
    if (JSON.stringify(object1) === JSON.stringify(object2)) {
        return true;
    } else {
        return false
    }
}

export const isChangedObject = (original, object) => {
    if (original === JSON.stringify(object)) {
        return false;
    } else {
        return true;
    }
}

export const getChangedObjects = (prevObj, curObj) => {
    let changedObjects = [];
    try {
        let obj = JSON.parse(prevObj);
        for (const i in obj) {
            if (obj[i] !== curObj[i])
                changedObjects.push({ [i]: curObj[i] });
        }

        return changedObjects;
    } catch (e) {
        console.log("LAMTEST getChangedObjects");
    }
    return changedObjects;
}

export const isOneStatusChanged = (changedObjects) => {
    let len = changedObjects.length;
    return changedObjects.find(item => {
        if (item.status && len === 1)
            return true;
        else if (item.status && item.history && len === 2)
            return true;
        else
            return false;
    })
}

export const convertObjectToString = (object) => {
    let newObject = { ...object };
    if (object) return JSON.stringify(newObject);

    return null;
}

export const convertStringToObject = (original) => {
    try {
        if (original) {
            let newObject = {};
            newObject = JSON.parse(original);
            return newObject;
        }
    } catch (err) {
        console.log("LAMTEST convertStringToObject");
        return false;
    }
}

export const isObjectsEmpty = (objects) => {
    for (let i in objects) {
        if ((objects[i] && !Array.isArray(objects[i])) || (objects[i] && Array.isArray(objects[i]) && objects[i].length > 0)) {
            return false;
        }
    }
    return true;
}

export const checkLanguage = (data) => {
    let lg = '';
    if (data && data !== '') {
        lg = data.toUpperCase();
    } else lg = 'DE';
    return lg;
}

export const changeLanguageForUser = (uilanguage, stateLanguage) => {
    let language = uilanguage;
    if (uilanguage && uilanguage !== "" && !isPMDB()) language = uilanguage.substr(0, 2);

    if (language !== "" && language !== stateLanguage) {
        return language;
    }
    return null;
}

export const sliceName = (name, len) => {
    let data = name;
    if (name && name.length > len) {
        return data = name.slice(0, len) + '...';
    }
    return data;
}

export const sliceTitleForGrid = (title) => {
    return sliceName(title, 40);
}

export const sliceShortName = (name, len) => {
    let data = name;
    if (name && name.length > len) {
        return data = name.slice(0, len);
    }
    return data;
}

export const setInitialObjState = (propsId, propsName, storeObjects, lg) => {
    let obj = [];
    if (storeObjects) {
        Object.keys(storeObjects).map(id => {
            obj.push({
                id: storeObjects[id][propsId],
                DE: storeObjects[id][propsName],
                EN: storeObjects[id][propsName]
            });
        });
        obj = obj.sort(dynamicSortAndIgnoreCase(lg));
        return obj;
    }
};


export const checkBasicFields = (basicData, objects, userrole) => {
    let result = true;
    if (Array.isArray(basicData) && basicData.length > 0) {
        basicData.map((item) => {
            if (userrole === CustomTypes.ROLE_LEVEL0
                || userrole === CustomTypes.ROLE_LEVEL1 /*|| userrole === CustomTypes.ROLE_LEVEL2*/) {
                if ((!objects[item.name] || objects[item.name] === "") && item.name != 'status' && item.name != CustomTypes.RIGHTS_FIELD) result = false;
            } else {
                if ((!objects[item.name] || objects[item.name] === "") && item.name != CustomTypes.RIGHTS_FIELD) result = false;
            }
        })
    }
    return result;
}

export const showRequiredFields = (basicData, objects, userrole) => {
    let requiredObj = {};
    if (Array.isArray(basicData) && basicData.length > 0) {
        basicData.map((item) => {
            if (userrole === CustomTypes.ROLE_LEVEL0
                || userrole === CustomTypes.ROLE_LEVEL1 /*|| userrole === CustomTypes.ROLE_LEVEL2*/) {
                if ((!objects[item.name] || objects[item.name] === "") && item.name != 'status' && item.name != CustomTypes.RIGHTS_FIELD) requiredObj = { ...requiredObj, [`${item.name}_isRequired`]: true };
                else requiredObj = { ...requiredObj, [`${item.name}_isRequired`]: false };
            } else {
                if ((!objects[item.name] || objects[item.name] === "") && item.name != CustomTypes.RIGHTS_FIELD) requiredObj = { ...requiredObj, [`${item.name}_isRequired`]: true };
                else requiredObj = { ...requiredObj, [`${item.name}_isRequired`]: false };
            }
        })
    }
    return requiredObj;
}


export const displayRequiredFields = (data, objects) => {
    let requiredObj = {};
    if (Array.isArray(data) && data.length > 0) {
        data.map((el) => {
            let subData = el.data;
            if (subData && subData.length > 0) {
                subData.map(item => {
                    if ((((((!objects[item.name] || objects[item.name] === "") && item.mandatory) ||
                        ((!objects[item.name] || objects[item.name] === "")
                            && objects[item.condition.name] === item.condition.value && objects[item.condition.name] !== "customdisplay" && item.condition.required)))
                        && ((((!objects[`${item.name}_ids`] || objects[`${item.name}_ids`] === "") && item.mandatory) ||
                            ((!objects[`${item.name}_ids`] || objects[`${item.name}_ids`] === "")
                                && objects[item.condition.name] === item.condition.value && objects[item.condition.name] !== "customdisplay" && item.condition.required))))

                        || ((!objects[item.name] || objects[item.name] === "") && (!objects[`${item.name}_ids`] || objects[`${item.name}_ids`] === "")
                            && ((objects[`${item.condition.name}_ids`] && (objects[`${item.condition.name}_ids`] == item.condition.value || objects[`${item.condition.name}_ids`].includes(item.condition.value)))
                                && item.condition.required))) {
                        requiredObj = { ...requiredObj, [`${item.name}_isRequired`]: true };
                    }

                    else requiredObj = { ...requiredObj, [`${item.name}_isRequired`]: false };
                })
            }
        })
    }

    return requiredObj;
}

export const validateFieldsForApp = (objects) => {
    let isValid = true;
    for (let i in objects) {
        if (objects[i]) isValid = false;
    }

    return isValid;
}

const cleanUpData = (item, objects) => {
    if ((item.condition.value && item.condition.name !== "customdisplay") && (item.condition.ext.value && item.condition.ext.name === "customdisplay")) {
        if (!objects[item.condition.name] || objects[item.condition.name] === "" || (objects[item.condition.name] !== item.condition.value)) {
            if (objects[item.name] && !(objects[`${item.condition.name}_ids`].includes(item.condition.value))) {
                delete objects[item.name];
                delete objects[`${item.name}_ids`];
            }
        }
    }

    else if ((item.condition.value && item.condition.name === "customdisplay") && (item.condition.ext.value && item.condition.ext.name !== "customdisplay")) {
        if (!objects[item.condition.ext.name] || objects[item.condition.ext.name] === "" || (objects[item.condition.ext.name] !== item.condition.ext.value)) {
            if (objects[item.name]) {
                delete objects[item.name];
                delete objects[`${item.name}_ids`];
            }
        }
    }

    else if ((item.condition.value && item.condition.name !== "customdisplay") && (item.condition.ext.value && item.condition.ext.name !== "customdisplay")) {
        if ((!objects[item.condition.ext.name] || objects[item.condition.ext.name] === "" || (objects[item.condition.ext.name] !== item.condition.ext.value)) &&
            (!objects[item.condition.name] || objects[item.condition.name] === "" || (objects[item.condition.name] !== item.condition.value))) {
            if (objects[item.name]) {
                delete objects[item.name];
            }
        }
    }
    return objects;
}

export const updateDataForApp = (objects, currentState) => {
    let term = null;
    if (AppController.isFrancetv()) term = "_ids";
    if (AppController.isNLW()) term = "_program";
    if (term) {
        for (let i in objects) {
            if (i.endsWith(term)) {
                let changed = i.slice(0, i.length - term.length);
                objects[changed] = objects[i];
                delete objects[i];
            }
            if (isNLW()) {
                if (i === CustomTypes.API_PROGRAMORSERIES
                    && (!objects[CustomTypes.API_SERIES_PARENT] || (currentState[`${CustomTypes.API_PROGRAMORSERIES}_tmp`]).includes(CustomTypes.MW_SERIES_SERIES))) {
                    objects[CustomTypes.API_SERIES_PARENT] = objects[i];
                }
            }
        }
    }
    return objects
}


export const doValidationForApp = (data, objects, currentState = null) => {
    if ((AppController.isFrancetv() || AppController.isNLW()) && data && data.length > 0) {
        data.map((el) => {
            let subData = el.data;
            if (subData && subData.length > 0) {
                subData.map(item => {
                    objects = cleanUpData(item, objects);
                    if (item.inputType === "CustomSubForm") {
                        let subFormData = item.data;
                        subFormData.map(subform => {
                            if (subform.data && subform.data.length > 0) {
                                let subSection = subform.data;
                                subSection.map(subitem => {
                                    objects = cleanUpData(subitem, objects);
                                });
                            }

                        });
                    }
                })
            }
        })
    }
    objects = updateDataForApp(objects, currentState);
    return objects;
}


//RIGHTS TAB BEGIN
export const setRightsData = (data, objects) => {
    let rightsObj = { ...objects };
    if (Array.isArray(data) && data.length > 0) {
        data.map((item) => {
            if (item.name && rightsObj[item.name]) {
                rightsObj[item.name] = "";
                rightsObj[`${item.name}Items`] = [];
                rightsObj[`${item.name}_ids`] = "";
            }
            if (item.nameIn) rightsObj[item.nameIn] = "";
            if (item.nameOut) rightsObj[item.nameOut] = "";
        })
    }
    return rightsObj;
}

const getRightsData = ({ formConfig }) => {
    let rightsConfig = [];
    if (formConfig && formConfig[0].data) {
        let exists = formConfig[0].data.find(el => el.maintab && el.maintab === "rights");
        if (exists) rightsConfig = exists.data;
    }
    return rightsConfig;
}

export const initRightsObjects = ({ rightsData, objects, formConfig }) => {
    let rightsObj = { ...objects };
    let rightsConfig = getRightsData({ formConfig });
    if (Array.isArray(rightsData) && rightsData.length > 0 && rightsConfig && rightsConfig.length) {
        rightsData.forEach(item => {
            let existsObj = rightsConfig.find(e => e.name === item);
            if (existsObj && existsObj.data) rightsObj = setRightsData(existsObj.data, rightsObj);
        })
    }
    return rightsObj;
}

export const checkRightsData = (data, rightsObj) => {
    let result = false;
    if (Array.isArray(data) && data.length > 0) {
        data.map((item) => {
            if (item.name && rightsObj[item.name] && (rightsObj[item.name] != "" || rightsObj[`${item.name}Items`])) result = true;
            if (item.name && rightsObj[item.name] && rightsObj[`${item.name}Items`] && rightsObj[`${item.name}Items`].length) result = true;
            if (item.nameIn && rightsObj[item.nameIn] && rightsObj[item.nameIn] != "") result = true;
            if (item.nameOut && rightsObj[item.nameOut] && rightsObj[item.nameOut] != "") result = true;
        })
    }
    return result;
}

export const checkRightsObjects = ({ rightsObj, formConfig }) => {
    let rightsDataItems = rightsObj[`${CustomConfig.customrights.name}Items`];
    let rightsConfig = getRightsData({ formConfig });
    if (!rightsDataItems || !rightsDataItems.length) {
        return rightsConfig.every(item => checkRightsData(item.data, rightsObj));
    } else {
        let filterItems = rightsConfig.filter(el => !rightsDataItems.find(e => e == el.name));
        if (filterItems && !filterItems.length) return true;
        if (filterItems && filterItems.length && filterItems.every(item => checkRightsData(item.data, rightsObj))) return true;
    }
    return false;
}
//RIGHTS TAB END

export const changeTime = (date) => {
    let hours = 2;
    let newDate;
    if (date instanceof Date)
        return newDate = new Date(date.getTime() + 1000 * (60 * (60 * (hours))));

    return date;
}

export const showMessage = (message) => {
    SweetAlert.fire({ position: 'center', html: "<p>" + message + "</p>", width: '500px', showConfirmButton: true, confirmButtonColor: '#403F45' })
}

export const showIntlMsg = (message) => {
    SweetAlert.fire({ text: message, width: '500px', showConfirmButton: true, confirmButtonColor: '#403F45' })
}

export const getModelYears = () => {
    let modelYears = [];
    let currentTime = new Date();
    let year = currentTime.getFullYear();

    let month = currentTime.getMonth();
    if (month > 10) {
        year += 1;
    }

    for (let i = 1948; i <= year; i++) {
        modelYears.push({ ID: i.toString(), DE: i.toString(), EN: i.toString() });
    }
    return modelYears;
}

export const removeEmptyObjects = (objects) => {
    for (const i in objects) {
        if ((typeof objects[i] === undefined) || objects[i] === null || objects[i] === "" || (typeof objects[i] === 'undefined')
            || (Array.isArray(objects[i]) && objects[i].length === 0)) {
            delete objects[i];
        }
    }
    return objects;
}

export const removeObjectElement = (objects, element) => {
    let tmpObj = { ...objects };

    for (const i in tmpObj) {
        if (i === 'selectedObjects') {
            delete tmpObj[i];
        }
    }
    return tmpObj;
}

export const removeObject = (objects, objectKey) => {
    let updatedObj = {};
    updatedObj = objects;

    Object.keys(updatedObj).map(key => {
        if (key === objectKey) delete updatedObj[key];
    })
    return objects;
}

export function convertObjects2strObj(objects, strObjName, delimiter) {
    let objArr = [];
    let convertedObj = "";
    for (const i in objects) {
        if ((i !== 'appId') && (i !== 'masterClipId') && (i !== 'selectedObjects') && (i !== 'oneClip')
            && (i !== 'user') && (i !== 'uploader') && (i !== 'createdby') && (i !== 'workflow') && (!i.includes("_ids") && (i !== 'history'))) {
            if (isFrancetv() && i === 'slider' && objects[i] === 1) objArr.push("slider");
            else if (isFrancetv() && i === 'useasthumbnail' && objects[i] === 1) objArr.push("useasthumbnail");
            else objArr.push(objects[i]);
        }
    }
    convertedObj = objArr.join(delimiter);
    return { [strObjName]: convertedObj }
}

export function writeName(name) {
    if (name) {
        let firstChar = name.charAt(0).toUpperCase();
        return (firstChar + name.substr(1));
    }
    return name;
}

export function convertUsername2Name(username) {
    let firstName = "";
    let lastName = "";
    if (username.includes('.')) {
        firstName = subStringBefore(username, ".");
        lastName = subStringAfter(username, ".");
        firstName = writeName(firstName);
        lastName = writeName(lastName);
        return (`${firstName} ${lastName}`);
    }
    return username;
}

export function convertEmail2Name(email) {
    let name = "";
    if (email.includes("@")) {
        name = subStringBefore(email, "@");
        name = convertUsername2Name(name);
        return name;
    }
    return email;
}

export const updateUploadObjects = (obj) => {
    let objects = { ...obj };

    for (let i in objects) {
        if (i.endsWith('Items') || i.endsWith('_tmp') || i.endsWith('_checked') || i === 'selectedObjects'
            || objects[i] === '' || !objects[i]
            || i === 'file' || i === 'oneClip' || i === `${CustomTypes.API_COUNTRIES}_ids` || i === 'user')
            delete objects[i];
    }
    return (objects);
}

export function getMetadata(obj) {
    if ((obj.appId && obj.appId !== 'PMDB') || (!isPMDB())) {
        let checkedObj = removeEmptyObjects(obj);
        if (isFrancetv()) {
            let user = (obj.user && obj.user.id) ? obj.user.id : "";
            let history = { date: getCurrentDayTimestamp(), action: "upload", user };
            checkedObj.history = JSON.stringify(history);
        }

        if (obj.appId == CustomTypes.MASTER_UPLOAD_FORM) {

            return convertObjects2strObj(checkedObj, "tags", ",");
        }
        if (checkedObj.selectedObjects) {
            let sendObj = {};
            sendObj = removeObjectElement(checkedObj, "selectedObjects");
            if (isFrancetv() && sendObj.workflow) delete sendObj.workflow;
            return { ...sendObj }
        }

        return { ...checkedObj };
    } else {
        let history = { date: getCurrentDayTimestamp(), action: "upload", user: obj.user.id };
        let newObjects = {
            ...obj,
            videoinhalte: obj.videoinhalte_ids || "",
            [CustomTypes.API_COUNTRIES]: obj[`${CustomTypes.API_COUNTRIES}_ids`],
            history: JSON.stringify(history),
            status: obj.status || 'vorbereitung'
        };
        newObjects = updateUploadObjects(newObjects);
        return newObjects;
    }
}

export const showElementMsg = (message, elemId, color = CustomTypes.COLOR_TEXT) => {
    let pUploadedElem = document.getElementById(elemId);
    if ((message !== "") && (pUploadedElem)) {
        pUploadedElem.innerHTML = message;
        pUploadedElem.style.cssFloat = "right";
        pUploadedElem.style.fontSize = CustomTypes.HEADING_1;
        pUploadedElem.style.color = color;
    }
}

export const showElements = (fileId, width, message, elemId) => {
    let progressBar = document.getElementById('pB' + fileId);
    let status = document.getElementById('p' + fileId);
    if (progressBar) {
        progressBar.style.width = width + '%';
        status.innerHTML = width + '%';
        showElementMsg(message, elemId);
    }
}

export const removeElements = (selectedObjects) => {
    selectedObjects.map(item => {
        document.getElementById('p' + item.fileId).remove();
        document.getElementById('pB' + item.fileId).remove();
    })
}

export const checkVideoFiles = (filetype) => {
    if (filetype.startsWith("video/")) return true;
}

export const setElemPosition = (elemId, obj, event) => {
    let divElemt = document.getElementById(elemId);
    let e = event || window.event;
    let top = (divElemt.offsetTop - (obj.pos4 - e.clientY));
    let left = (divElemt.offsetLeft - (obj.pos3 - e.clientX));
    if ((top >= mainToolbarHeight) && (left >= 0) && (left <= obj.maxLeft) && (top <= obj.maxTop)) {
        divElemt.style.top = top + "px";
        divElemt.style.left = left + "px";
    }
}

export const getClipPath = (clipId, clips) => {
    let filePath = '';
    for (let i = 0; i < clips.length; i++) {
        let clip = clips[i];
        if (clip.id === clipId) {
            let fileUrl = clip.mainthumbnail;
            let searchTerm = '?file=';
            let indexOfFirst = fileUrl.indexOf(searchTerm);
            filePath = fileUrl.substring(indexOfFirst + 6);
            if (filePath !== '') {
                return filePath;
            }
        }
    }
    return filePath;
}

export const getMediaUrl = (clipUrl) => {
    let mediaUrl = '';
    let searchTerm = '?file=';
    let indexOfFirst = clipUrl.indexOf(searchTerm);
    mediaUrl = clipUrl.substring(0, indexOfFirst);
    return mediaUrl;
}

export const getMediaPath = (clipUrl) => {
    let mediaPath = '';
    let searchTerm = '?file=';
    let indexOfFirst = clipUrl.indexOf(searchTerm);
    mediaPath = clipUrl.substring(indexOfFirst + 6);

    return mediaPath;
}

export const subStringBefore = (str, searchTerm) => {
    let substr = '';
    let indexOfFirst = str.indexOf(searchTerm);
    substr = str.substring(0, indexOfFirst);
    return substr;
}

export const subStringAfter = (str, searchTerm) => {
    let substr = '';
    let indexOfFirst = str.indexOf(searchTerm);
    substr = str.substring(indexOfFirst + searchTerm.length);
    return substr;
}

export const getClipUrl = (clipId, clips) => {
    let clipUrl = '';
    for (let i = 0; i < clips.length; i++) {
        let clip = clips[i];
        if (clip.id === clipId) {
            clipUrl = clip.mainthumbnail;
            return clipUrl;
        }
    }
    return clipUrl;
}

export const convertStringToArray = (data) => {
    let dataArr = data.split(';');
    return dataArr;
}

export const resizeTextArea = (event) => {
    const { name } = event.target;
    let elementId = name + 'areaTxtId';
    if (document.getElementById(elementId)) document.getElementById(elementId).style.height = "auto";

    const textareaLineHeight = 23;
    const previousRows = event.target.rows;
    event.target.rows = CustomTypes.MIN_ROWS;
    const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);
    if (currentRows === previousRows) {
        event.target.rows = currentRows;
    }
    if (currentRows >= CustomTypes.MAX_ROWS) {
        event.target.rows = CustomTypes.MAX_ROWS;
        event.target.scrollTop = event.target.scrollHeight;
    }
    return currentRows < CustomTypes.MAX_ROWS ? currentRows : CustomTypes.MAX_ROWS;
}

export const dynamicSort = (property) => {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

export const isDataArray = (data) => {
    if (Array.isArray(data) && data.length > 0) return true;

    return false
}

export const uniqueArray = (data) => {
    let objArr = [...data];
    objArr = objArr.reduce((acc, cur) => [
        ...acc.filter((obj) => getId(obj) !== getId(cur)), cur
    ], []);
    return objArr;
}

export const uniqueArrayStr = (data) => {
    let objArr = [...data];
    objArr = objArr.reduce((acc, cur) => [
        ...acc.filter((obj) => obj !== cur), cur
    ], []);
    return objArr;
}

export const getTitleByLangAndAppId = (appId, lg, data) => {
    try {
        switch (appId) {
            case 'PMDB':
            case 'SAPDemo':
                if (lg === 'de' && data.titel_de) return data.titel_de;
                if (lg == 'en' && data.titel) return data.titel;
            default:
                if (lg === 'de') return data.titel_de || data.titel || data.title;
                if (lg == 'en') return data.titel_en || data.titel || data.title;
        }
    } catch (error) {
        return "";
    }
}

export const getClipIdByAppId = (appId, data) => {
    try {
        switch (appId) {
            case 'PMDB':
            case 'SAPDemo':
                if (data.id) return data.id;
            default:
                return data.id || data.clipid;
        }
    } catch (error) {
        return "";
    }
}

export const getLanguage = (language) => {
    let lg = "EN";
    if (language && language != "") {
        lg = language;
        lg = lg.toUpperCase();
        if (!AppController.isOkno()) {
            if (lg !== "DE" && lg !== "EN") lg = "EN";
        }
    }
    return lg;
}

export const sortData = (data, lg) => {
    if (Array.isArray(data) && data.length > 0) {
        let newdata = [...data];
        return newdata.sort(dynamicSortAndIgnoreCase(lg));
    }
    return data;
}

export const getId = (obj) => {
    if (obj.ID) return obj.ID;
    if (obj.id) return obj.id;
    if (obj.Id) return obj.Id;

}

export const filterObjects = (obj, needed) => {
    let newobj = { ...obj };
    Object.keys(newobj).map((key) => {
        if (!key.endsWith(needed)) delete newobj[key];
    })
    return newobj;
}

export const getFormStyle = (data) => {
    let elements_count = 0;
    let left_count = 0;
    if (Array.isArray(data) && data.length > 0) {
        data.map((item, index) => {
            let elem = item.data;

            if (Array.isArray(elem) && elem.length > 0) {
                elements_count += elem.length;
            }
            if (elements_count < 13) {
                return left_count = index;
            }
        })
    }
    return left_count;
}

export const checkEnableFields = (field, userrole, formDesign) => {
    if (isPMDB() && (formDesign === CustomTypes.UPLOAD_FORM || formDesign === CustomTypes.SEARCH_FORM)
        && field === CustomTypes.STATUS && (userrole && (userrole === CustomTypes.ROLE_LEVEL0
            || userrole === CustomTypes.ROLE_LEVEL1 /*|| userrole === CustomTypes.ROLE_LEVEL2*/))) {
        return false;
    }
    return true;
}

export const changeTitle = (title, id) => {
    let newTitle = title;
    if (title && title !== "")
        newTitle = title + "_" + id;
    else
        newTitle = id;

    return newTitle;
};

export const changeTitleByAppId = (obj, id) => {
    let newTitleObj = {};

    for (let i in obj) {
        if (isPMDB()) {
            if (i === "titel_de" || i === "titel") {
                newTitleObj = { ...newTitleObj, [i]: changeTitle(obj[i], id) };
            }
        } else {
            if (i == "titel_en" || i === "titel_de" || i === "titel" || i == "title") {
                newTitleObj = { ...newTitleObj, [i]: changeTitle(obj[i], id) };
            }
        }
    }
    return newTitleObj;
}

export const checkTimeout = (time) => {
    if (time > MAX_TIMEOUT) {
        return true;
    }
    return false;
}

export const showStatusMessage = (pcObj, timerId, callback, elemId) => {
    if (checkTimeout(pcObj.actionTime)) {
        showElementMsg("Server Connection Error ...", elemId, CustomTypes.COLOR_RED);
        delay(5000).then(() => {
            clearInterval(timerId);
            callback();
        })
    }
}

export const sendMessageEmail = (message, email) => {
    //let emailText = "Bitte die Metadaten zu ID" + message + " nachtragen!";
    let emailText = "<p> Bitte die Metadaten zu ID" + message + " nachtragen! </p>";
    emailText += "<p> Diese Anfrage kommt von: " + email + "</p>";
    let emailObj = {
        to: CustomTypes.HELP_EMAIL,
        //cc: email,
        subject: 'Metadaten nachtragen!',
        html: emailText,
        text: emailText,
    }

    return emailObj;
}


export const showProgressBar = (pcObj, width, formatMessage, elementId) => {
    if ((typeof pcObj.id) && (pcObj.fileId === pcObj.id)) {
        let uploadMessage = formatMessage({ id: `customdata.${pcObj.uploadMessageId}` });
        width = pcObj.uploading;
        showElements(pcObj.id, width, "");
        if ((pcObj.actionTime > 0))
            showElementMsg(uploadMessage, elementId);
        else
            showElementMsg(uploadMessage, elementId);
    }
}

export const setIdForDivElement = (data) => {
    let divElementId = "uploadprogressbarFileDivId";

    if (data.url) return (divElementId + data.url);
    else if (data.id) return (divElementId + data.url);

    return divElementId;
}

export const removeFileFromObjectData = (divElementId, data, property) => {
    let fileUrl = subStringAfter(divElementId, "uploadprogressbarFileDivId");
    let newObjects = [];
    newObjects = [...data];
    return newObjects.filter(item => item[property] !== fileUrl);
}

export const updateObjectData = (data) => {
    let newObjects = [];
    newObjects = [...data];
    let i = 0;
    for (let object of newObjects) {
        object.fileId = i;
        i++;
    }
    return newObjects;
}

export const showSelectedObject = (elementList, elementId) => {
    for (let element of elementList) {
        let divElementId = setIdForDivElement(element);
        let deleteIconId = getDeleteIconId(divElementId);
        if (divElementId !== elementId) {
            document.getElementById(divElementId).style.border = "none";
            document.getElementById(deleteIconId).src = AppController.CustomAppEventListener("getIcon", "deleteOff");
        } else {
            document.getElementById(elementId).style.border = "1px solid red";
            document.getElementById(getDeleteIconId(divElementId)).src = AppController.CustomAppEventListener("getIcon", "deleteOn");
        }
    }
}

export const setDefaultValueForList = (elementList) => {
    for (let element of elementList) {
        let divElementId = setIdForDivElement(element);
        let deleteIconId = getDeleteIconId(divElementId);
        document.getElementById(divElementId).style.border = "none";
        document.getElementById(deleteIconId).src = AppController.CustomAppEventListener("getIcon", "deleteOff");
    }
}

export const getDeleteIconId = (elementId) => {
    return (elementId + "DeleteIcon");
}

export const getPartYearOfDate = (date) => {
    let newYear = date;
    newYear = subStringAfter(newYear, ".");
    if (newYear.includes(".")) {
        newYear = subStringAfter(newYear, ".");
    }
    if (newYear.length === 4)
        return newYear.substring(2, 4);

    return null;
}

export const getFullYearOfDate = (date) => {
    let newYear = date;
    newYear = subStringAfter(newYear, ".");
    if (newYear.includes(".")) {
        newYear = subStringAfter(newYear, ".");
    }

    if (newYear.length === 4)
        return newYear;

    return null;
}

export const changeDateForProject = (date) => {
    let fullYear_tmp = getFullYearOfDate(date);
    let year_tmp = getPartYearOfDate(date);
    if (fullYear_tmp && year_tmp) {
        let date_tmp = subStringBefore(date, fullYear_tmp);
        let newDate = date_tmp + year_tmp;
        if (newDate && newDate !== "" && newDate.length === 8) return newDate;
    }
    return date;
}

export const sortByProperty = (function () {
    var toString = Object.prototype.toString,
        parse = function (x) { return x; },
        getItem = function (x) {
            var isObject = x != null && typeof x === "object";
            var isProp = isObject && this.prop in x;
            return this.parser(isProp ? x[this.prop] : x);
        };

    return function sortby(array, cfg) {
        if (!(array instanceof Array && array.length)) return [];
        if (toString.call(cfg) !== "[object Object]") cfg = {};
        if (typeof cfg.parser !== "function") cfg.parser = parse;
        cfg.desc = !!cfg.desc ? -1 : 1;
        return array.sort(function (a, b) {
            a = getItem.call(cfg, a);
            b = getItem.call(cfg, b);
            return cfg.desc * (a < b ? -1 : +(a > b));
        });
    };
}());

export const sortDataForProjects = (data, option) => {
    if (Array.isArray(data) && data.length > 0) {
        switch (option) {
            case "dateDESC":
                return sortByProperty(data, { prop: CustomTypes.SORT_CREATED, desc: true });
            case "dateASC":
                return sortByProperty(data, { prop: CustomTypes.SORT_CREATED });
            case "projectName":
                return sortByProperty(data, { prop: "name" });
            case "roomTitle":
                return sortByProperty(data, { prop: "title" });
            case "projectType":
                return sortByProperty(data, { prop: "projecttype" });
        }
    }
    return data;
}

export const parseISOString = (s) => {
    var b = s.split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
}

export const isoStringToDate = (date) => {
    let d = parseISOString(date);

    function pad(n) { return (n < 10 ? '0' : '') + n }
    return pad(d.getUTCDate()) + '.' + pad(d.getUTCMonth() + 1) + '.' + d.getUTCFullYear() + " " + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds());
}

export const getCurrentDayTimestamp = () => {
    const d = new Date();
    return new Date(
        Date.UTC(
            d.getFullYear(),
            d.getMonth(),
            d.getDate(),
            d.getHours(),
            d.getMinutes(),
            d.getSeconds()
        )
        // "2017-08-22T08:32:32.847Z"
    ).toISOString();
}


export const sortAllActions = (data, users, original = false) => {
    let sortedData = sortByProperty(data, { prop: "date", desc: true });
    let newData = [];
    for (let obj of sortedData) {
        if (obj["date"]) {
            let newDate = isoStringToDate(obj["date"]);
            if (original) obj = { ...obj, date: newDate, originaldate: obj["date"] };
            else obj = { ...obj, date: newDate };
        }
        if (obj["user"]) {
            let newUser = getUserNameById(obj["user"], users);
            obj = { ...obj, user: newUser };
        }
        newData.push(obj);
    }
    return newData;
}

export const getDataForTable = (data, users, original = false) => {
    console.log("getDataForTable data", data);
    if (data) {
        let obj = {};
        let newData = data;
        if (data.charAt(0) === ',') {
            newData = data.substring(1, data.length);
        }

        if (newData.includes("}{")) {
            let regex = /}{/ig;
            newData = newData.replace(regex, '},{');
        }
        newData = '{"history" : [' + newData + ']}'
        try {
            obj = JSON.parse(newData);
            if (obj.history && Array.isArray(obj.history) && obj.history.length > 0) {
                return sortAllActions(obj.history, users, original);
            }
            return [obj];
        } catch (eror) {
            console.log("LAMTEST error JSON.parse");
        }
    }
    return [{ "date": "", "action": "", "user": "" }];
}

export const updateHistoryData = (user, action) => {
    if (user) {
        let obj = {};
        try {
            if (action && action !== "") {
                obj = { "date": getCurrentDayTimestamp(), "action": action, "user": user };
                return "," + JSON.stringify(obj);
            }
        } catch (eror) {
            console.log("LAMTEST error JSON.parse");
        }
    }
    return [{ "date": "", "action": "", "user": "" }];
}

export const refreshCurrentData = (data, action) => {
    if (data && data.clipid) {
        let currentHistory = data.history + action;
        return { clipid: data.clipid, history: currentHistory }
    }
    return null;
}

export const findElementByProperty = (data, property, propertyValue) => {
    let found = null;
    for (const item of data) {
        if (item[property] === propertyValue) {
            found = item;
            break;
        }
    }
    return found;
}

export const getLongData = (list, shortData) => {
    let data;
    data = shortData.map(id => {
        return list[id];
    });
    return data;
}

export const ObjectLength = (object) => {
    let length = 0;
    for (let key in object) {
        length++;
    }
    return length;
};

export const getProjectState = (project) => {
    if (project.private) {
        if ((project.members instanceof Array) && (project.members.length > 0)) {
            return <FormattedMessage id="page.projects.state.shared" />
        } else
            return <FormattedMessage id="page.projects.state.private" />
    } else
        return <FormattedMessage id="page.projects.state.public" />
}

export const updateDataTree = (data, deletedData) => {
    try {
        let newData = data;
        let found = false;
        Object.keys(data).map((item) => {
            let deleted = "" + data[item].id;
            if (deletedData.indexOf(deleted) !== -1) {
                found = true;
                newData.splice(item, 1);
            }
        })

        if (found)
            return newData;
    } catch (e) {
        // console.log("updateDataTree");
    }
    return null;
}

export const convertObjectKeyData = (data) => {
    try {
        let newData = [];
        Object.keys(data).map((item) => {
            if (data[item].data)
                newData.push(data[item].data)
        })
        if (newData.length > 0)
            return newData;
    } catch (e) {
        console.log("LAMTEST convertObjectKeyData");
    }
    return data;
}

const RIGHTS_DATA = [
    { ID: "unlimited", DE: "uneingeschränkt", EN: "no restriction" },
    { ID: "limited", DE: "uneingeschränkt", EN: "restriction" }
]
export const getRightsDataForTable = (data, language) => {
    let rights = null;
    let lg = getLanguage(language);

    if (data === CustomTypes.UNLIMITED) rights = "unlimited";
    else rights = "unlimited";
    for (const obj of RIGHTS_DATA) {
        if (obj.ID === rights)
            return obj[lg];
    }
    return data;
}

export const isIsoString = (date) => {
    try {
        const tmp = date;
        if (new Date(tmp) !== "Invalid Date" && !isNaN(new Date(tmp))) {
            if (tmp == new Date(tmp).toISOString()) {
                return true;
            }
        }
        return false;
    } catch (err) {
        return false;
    }
}

export const addTimeToDate = (objects, item, term, option) => {
    let date;
    if (objects && term) {
        try {
            if (item.includes(`_${term}`)) {
                let original = subStringBefore(item, `_${term}`);
                if (objects[`${original}_${option}${term}`]) {
                    let time = objects[`${original}_${option}${term}`];
                    if (time.length === 8) {
                        let hours = subStringBefore(time, ":");
                        let tmp = subStringAfter(time, ":");
                        let minutes = subStringBefore(tmp, ":");
                        let seconds = subStringAfter(tmp, ":");
                        date = objects[item];
                        date.setHours(hours);
                        date.setMinutes(minutes);
                        date.setSeconds(seconds);
                        return date;
                    }
                } else {
                    if (item.includes("_ToDateTime")) {
                        date = objects[item];
                        date.setHours("23");
                        date.setMinutes("59");
                        date.setSeconds("59");
                        return date;
                    }
                }
            }
        } catch (err) {
            console.log("LAMTEST addTimeToDate Error");
        }
    }
    return null;
}

export const changeDateFormat = ({ date, dateFormat, isShort }) => {
    let d;
    let format = dateFormat || "dd.MM.yyyy";
    format = format.toLowerCase();
    if (!date) d = new Date();
    else d = newDate(date);
    function pad(n) { return (n < 10 ? '0' : '') + n }
    let newDate = format.replace("yyyy", d.getFullYear());
    // newDate = newDate.replace("MM", pad(d.getMonth() + 1));
    newDate = newDate.replace("mm", pad(d.getMonth() + 1));
    newDate = newDate.replace("dd", pad(d.getDate()));
    if (isShort) return newDate;
    return newDate + " " + pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds());
}

export const convertDateToString = (date) => {
    if (date && typeof date == 'object') {
        return new Date(date).toISOString().slice(0, 10);
    }
    return '';
}

export const dynamicSortAndIgnoreCase = (property) => {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        if (a[property] && b[property]) {
            var result = (a[property].toUpperCase() < b[property].toUpperCase()) ? -1 : (a[property].toUpperCase() > b[property].toUpperCase()) ? 1 : 0;
            return result * sortOrder;
        }
        return 0;
    }
}

export const isImage = (file) => {
    let pattern = /.jpg$|.jpeg$|.JPEG$|.JPG$|.png$|.PNG$/i;
    return (file && file.search(pattern) > -1);
}


export const isJpegFile = (file) => {
    let pattern = /.jpg$|.jpeg$|.JPEG$|.JPG$/i;
    return (file && file.search(pattern) > -1);
}

export const setLevels4Obj = ({ propsId = "id", propsName = "name", lg, data, showLevel, obj }) => {
    if (data && data.length) {
        data.forEach(item => {
            if (item[propsId]) {
                obj.push({
                    id: item[propsId],
                    DE: item[propsName],
                    EN: item[propsName],
                    showLevel
                });
                if (item.children && item.children.length) {
                    setLevels4Obj({ lg, data: item.children, showLevel: showLevel + 1, obj });
                }
            }
        })
    }
    return obj;
};

export const setInitialLevelObj = ({ propsId = "id", propsName = "name", lg, tree }) => {
    let obj = [];
    let data = tree.map(item => ({ ...item.data, children: item.children }));
    data = data.sort(dynamicSortAndIgnoreCase(propsName));
    obj = setLevels4Obj({ lg, data, showLevel: 1, obj });
    return obj;
};




